import classNames from 'classnames';
import { ComponentProps } from 'react';

import borderRadiusAsClasses from '../../shared/borderRadiusAsClasses';
import AllCornersBorderRadius from '../../types/UI/AllCornersBorderRadius';
import Box from '../Box/Box';

import styles from './PaddedBox.module.css';

type PaddedBoxProps = {
    variant?: 'transparent' | 'white' | 'tint' | 'brand' | 'dark';
    borderRadius?: AllCornersBorderRadius;
    horizontalPadding?:
        | 'none'
        | 'xsmall'
        | 'small'
        | 'medium'
        | 'large'
        | 'xlarge'
        | 'xxlarge';
    verticalPadding?:
        | 'none'
        | 'xsmall'
        | 'small'
        | 'medium'
        | 'large'
        | 'xlarge'
        | 'xxlarge';
} & ComponentProps<typeof Box>;

const PaddedBox = ({
    variant = 'transparent',
    borderRadius = 'none',
    horizontalPadding = 'large',
    verticalPadding = 'large',
    className,
    ...boxProps
}: PaddedBoxProps) => {
    const classes = classNames(
        className,
        borderRadiusAsClasses(borderRadius, {
            size: 'large',
        }),
        {
            [styles.white]: variant === 'white',
            [styles.tint]: variant === 'tint',
            [styles.brand]: variant === 'brand',
            [styles.dark]: variant === 'dark',
            [styles.horizontalPaddingXXLarge]: horizontalPadding === 'xxlarge',
            [styles.horizontalPaddingXLarge]: horizontalPadding === 'xlarge',
            [styles.horizontalPaddingLarge]: horizontalPadding === 'large',
            [styles.horizontalPaddingMedium]: horizontalPadding === 'medium',
            [styles.horizontalPaddingSmall]: horizontalPadding === 'small',
            [styles.horizontalPaddingXSmall]: horizontalPadding === 'xsmall',
            [styles.verticalPaddingXXLarge]: verticalPadding === 'xxlarge',
            [styles.verticalPaddingXLarge]: verticalPadding === 'xlarge',
            [styles.verticalPaddingLarge]: verticalPadding === 'large',
            [styles.verticalPaddingMedium]: verticalPadding === 'medium',
            [styles.verticalPaddingSmall]: verticalPadding === 'small',
            [styles.verticalPaddingXSmall]: verticalPadding === 'xsmall',
        }
    );

    return <Box {...boxProps} className={classes} />;
};

export default PaddedBox;
